import { useState } from "react";
import { apiURL } from "../../consts/URLs"; 
import { fetchRequest, getOptions } from "../utils";
import { getCookie } from "../../utils/handleCookie";
import { cookieName } from "../../consts/cookie";

const token = getCookie(cookieName.token);

const useDelete = () => {
  const [deleteFileResponse, setDeleteFilesResponse] = useState<any>();
  const [deleteFileResult, setDeleteFileResult] = useState<any>();

  const deleteFile = (id: number, fileType: string) => {
    const url = `${apiURL}/${fileType}/${id}`;
    const options = getOptions({ method: "DELETE", token: token });
    fetchRequest(url, options, setDeleteFilesResponse, setDeleteFileResult);
  };

  return { deleteFileResponse, deleteFileResult, deleteFile };
};
export default useDelete;
